// England & Wales bank holidays for a year, as YYYY-MM-DD strings, so admins
// can fill the holiday list in one click instead of typing dates.
const iso = (y, m, d) => new Date(Date.UTC(y, m - 1, d)).toISOString().slice(0, 10);
const dow = (y, m, d) => new Date(Date.UTC(y, m - 1, d)).getUTCDay(); // 0 = Sunday
const addDays = (y, m, d, n) => new Date(Date.UTC(y, m - 1, d + n));

// Anonymous Gregorian algorithm for Easter Sunday.
export const easterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return { y: year, m: month, d: day };
};

// n-th (1-based) given weekday of a month; n = -1 means the last one.
const nthWeekday = (year, month, weekday, n) => {
  if (n > 0) {
    const first = dow(year, month, 1);
    return 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
  }
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return lastDay - ((dow(year, month, lastDay) - weekday + 7) % 7);
};

export const bankHolidays = (year) => {
  const out = [];
  const taken = new Set();
  const push = (date) => { out.push(date); taken.add(date); };
  // A holiday on a weekend moves to the next free weekday.
  const substitute = (y, m, d) => {
    let t = new Date(Date.UTC(y, m - 1, d));
    while ([0, 6].includes(t.getUTCDay()) || taken.has(t.toISOString().slice(0, 10))) {
      t = new Date(t.getTime() + 86400000);
    }
    push(t.toISOString().slice(0, 10));
  };

  substitute(year, 1, 1); // New Year's Day
  const easter = easterSunday(year);
  push(addDays(easter.y, easter.m, easter.d, -2).toISOString().slice(0, 10)); // Good Friday
  push(addDays(easter.y, easter.m, easter.d, 1).toISOString().slice(0, 10)); // Easter Monday
  push(iso(year, 5, nthWeekday(year, 5, 1, 1))); // Early May
  push(iso(year, 5, nthWeekday(year, 5, 1, -1))); // Spring
  push(iso(year, 8, nthWeekday(year, 8, 1, -1))); // Summer
  // Christmas Day and Boxing Day keep their order when substituted.
  substitute(year, 12, 25);
  substitute(year, 12, 26);
  return out.sort();
};
